query GetSunProtectionPageContent {
    GlobalSetting {
        nextButtonText
        finishOrderButtonText
        phoneNumber
        pricesIncludeVat
        windowDressingStep {
            stepName
            title
            content
        }
        productSelectionStep {
            stepName
            title
            content
        }
        colorsStep {
            stepName
            title
            content
        }
        overviewStep {
            stepName
            title
            content
        }
        decorationTypeStep {
            stepName
            title
            content
            windowDecorationDescription
            sunProtectionDescription
            windowDecorationImage {
                url
                alt
            }
            sunProtectionImage {
                url
                alt
            }
            videosSection {
                title
                description
                videos {
                    youtubeUrl
                    title
                    description
                }
            }
        }
    }
}
